module.exports = __webpack_public_path__ + "img/6a2d9c0.svg";